/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IUserActionSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.UserActionWorkflowBlock;
        processConfigId: string;
        isReadonly: boolean;
        buttonNameSameAsWorkflowBlockName: boolean;
        nameChanged(): void;
        placementFormChanged(): void ;
        placementForm: Wars.Domain.Model.Form;
        securityMatrix: Wars.Domain.Model.SecurityMatrix;
        backdatingSecurityMatrix: Wars.Domain.Model.SecurityMatrix;
        futureDatingSecurityMatrix: Wars.Domain.Model.SecurityMatrix;
        securityMatrixInfoLoaded: boolean;
        backdatingSecurityMatrixInfoLoaded: boolean;
        forms: Wars.Domain.Model.Form[];
        formSections: Wars.Domain.Model.FormSection[];
        manageSections: Wars.Domain.Model.ManageSection[];
        addNewFormValidation(): void;
        deleteFormValidation(dto: Wars.Domain.Model.Dtos.Workflow.FormValidationDto) : void;
}

    export class UserActionSettingsModalController extends BaseModalController {
        scope: IUserActionSettingsModalControllerScope;

        constructor(
            $scope: IUserActionSettingsModalControllerScope,
            $q: angular.IQService,
            securityMatrixService: services.SecurityMatrixService,
            workflowService: services.WorkflowService,
            formService: services.FormService,
            workflowBlock: models.UserActionWorkflowBlock,
            processConfigId: string,
            isReadonly: boolean,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.processConfigId = processConfigId;
            this.scope.isReadonly = isReadonly;
            this.scope.buttonNameSameAsWorkflowBlockName = workflowBlock.userActionDto.name === workflowBlock.userActionDto.buttonLabel;

            this.scope.nameChanged = () => this.nameChanged();
            this.scope.addNewFormValidation = () => this.addNewFormValidation();
            this.scope.deleteFormValidation = (dto: Wars.Domain.Model.Dtos.Workflow.FormValidationDto) => this.deleteFormValidation(dto);
            
            this.scope.placementFormChanged = () => this.placementFormChanged();

            formService.getProcessConfigurationFormsWithSections(this.scope.processConfigId).then((forms) => {
                this.scope.forms = forms;
                this.scope.placementForm = Enumerable.from(forms).singleOrDefault(i => i.id === this.scope.workflowBlock.userActionDto.userActionPlacementFormId);
                this.loadFormSections();
            });

            $q.all(
                [
                    securityMatrixService.fetchById(workflowBlock.userActionDto.securityMatrixId, "SecurityMatrix").then((securityMatrix) => this.scope.securityMatrix = securityMatrix),
                    securityMatrixService.fetchById(workflowBlock.userActionDto.backdatingSecurityMatrixId, "SecurityMatrix").then((backdatingSecurityMatrix) => this.scope.backdatingSecurityMatrix = backdatingSecurityMatrix),
                    securityMatrixService.fetchById(workflowBlock.userActionDto.futureDatingSecurityMatrixId, "SecurityMatrix").then((futureDatingSecurityMatrix) => this.scope.futureDatingSecurityMatrix = futureDatingSecurityMatrix)
                ])
                .then(() => this.scope.securityMatrixInfoLoaded = true);
        }

        public nameChanged(): void {
            if (this.scope.buttonNameSameAsWorkflowBlockName) this.scope.workflowBlock.userActionDto.buttonLabel = this.scope.workflowBlock.userActionDto.name;
        }

        public placementFormChanged() : void  {
            this.scope.workflowBlock.userActionDto.userActionPlacementFormId = this.scope.placementForm ? this.scope.placementForm.id : undefined;
            this.loadFormSections();
        }

        public addNewFormValidation(): void {
            this.scope.workflowBlock.userActionDto.myFormValidations.push({});
        }

        public deleteFormValidation(dto: Wars.Domain.Model.Dtos.Workflow.FormValidationDto): void {
            this.scope.workflowBlock.userActionDto.myFormValidations.remove(dto);
        }

        private loadFormSections(): void {
            if (this.scope.placementForm) {
                if (this.scope.placementForm.formType === Wars.Domain.Model.Codes.Enums.FormType.Manage) {
                    this.scope.workflowBlock.userActionDto.userActionPlacementFormSectionId = undefined;
                    this.scope.formSections = [];
                    this.scope.manageSections = this.scope.placementForm.myManageSections;
                } else {
                    this.scope.workflowBlock.userActionDto.userActionPlacementManageSectionId = undefined;
                    this.scope.formSections = Enumerable.from(this.scope.placementForm.mySteps).selectMany(i => i.formSections).toArray();
                    this.scope.manageSections = [];
                }
            } else {
                this.scope.formSections = [];
                this.scope.manageSections = [];
            }
        }
    }
}

warsApp.registerController('UserActionSettingsModalController',
    [
        '$scope', '$q', 'securityMatrixService', 'workflowService', 'formService', 'workflowBlock',
        'processConfigId', 'isReadonly', 'close'
    ]);